import { defineChain } from 'viem';
export const gelatoWagmi = /*#__PURE__*/ defineChain({
  id: 420001846,
  name: 'Gelato',
  nativeCurrency: { name: 'MockF', symbol: 'MOCKF', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.mysterious-present-place.t.raas.gelato.cloud/2ff2e1ea1a68484785779c5a072bed95'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Synfutures testnet explorer',
      url: 'https://synfutures-testnet.cloud.blockscout.com',
      apiUrl: 'https://synfutures-testnet.cloud.blockscout.com/api',
    },
  },
  contracts: {
    multicall3: {
      address: '0x69775e2767373c86c6A0cF5D30D9EE424De7c2a5',
      blockCreated: 22,
    },
  },
});
